import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { timeout, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { NotificationService } from './notification.service';
import { Router } from '@angular/router';
import { SharedService } from './shared.service';
import { VERBIAGE } from 'src/app/config';

@Injectable()

export class XHRIntercept implements HttpInterceptor {
    constructor(
        private _auth: AuthService, private _notify: NotificationService,
        private _router: Router, private _shared: SharedService
    ) {}

    intercept(req, next) {
        let headers = {
            'platform': 'browser',
            'application': 'Redbook',
            'version': '1.0.0'
        };

        if (this._auth.isAuthenticated) {
            headers['authorization'] = 'Bearer ' + sessionStorage.getItem('accessToken');    
        }

        return next.handle(req.clone({ setHeaders: headers })).pipe(
            timeout(10000),
            catchError((err): Observable<HttpEvent<any>> => {
                let title = 'Error Occurred',
                    body = 'Something went wrong, please login again to continue using application, if the error still exist please contact support.';

                if (err && err['name'] === 'TimeoutError') {
                    title = VERBIAGE.SERVICE_TIMEOUT_TITLE;
                    body = VERBIAGE.SERVICE_TIMEOUT_BODY;
                    err = new HttpErrorResponse({ status: 408, error: "Service timed out." });
                }

                if (err.status === 401 || err.status === 403) {
                    title = VERBIAGE.SESSION_EXPIRED_TITLE;
                    body = VERBIAGE.SESSION_EXPIRED_BODY;
                }
                
                const _this = this;
                this._notify.openDialog({
                    color: 'warn', title, body,
                    handlers:[
                        { color: 'warn', type: '-raised-', text: 'OK', action() {
                            sessionStorage.clear();
                            _this._router.navigate(['/']);
                            _this._shared.closeAllDialoges();
                        }}
                    ]
                });

                return throwError(err);
            })
        );
    }
}